import {
  ADD_COMMUNICATION_FAILED,
  DELETE_COMMUNICATION,
  DELETE_COMMUNICATION_FAILED,
  DELETE_COMMUNICATION_SUCCESS,
  GET_COMMUNICATION,
  GET_COMMUNICATION_FAILED,
  GET_COMMUNICATION_SUCCESS,
  GET_CUSTOM_EMAILS,
  GET_CUSTOM_EMAILS_FAILED,
  GET_CUSTOM_EMAILS_SUCCESS,
  GET_EVENTS_BY_SEARCH_FAILED,
  GET_EVENTS_BY_SEARCH_SUCCESS,
  GET_USERS_FAILED,
  GET_USERS_SUCCESS,
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILED,
  GET_NOTIFICATIONS_SUCCESS,
  GET_WEB_ALERTS,
  GET_WEB_ALERTS_FAILED,
  GET_WEB_ALERTS_SUCCESS,
  HIDE_DELETE_COMMUNICATION_MODAL,
  HIDE_SEND_COMMUNICATION_MODAL,
  HIDE_SEND_WEB_ALERT_MODAL,
  OPEN_DELETE_COMMUNICATION_MODAL,
  OPEN_SEND_COMMUNICATION_MODAL,
  OPEN_SEND_WEB_ALERT_MODAL,
  RESET_COMMUNICATION,
  SEND_COMMUNICATION,
  SEND_COMMUNICATION_FAILED,
  SEND_COMMUNICATION_SUCCESS,
  SEND_WEB_ALERT,
  SEND_WEB_ALERT_FAILED,
  SEND_WEB_ALERT_SUCCESS,
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_FAILED,
  UPDATE_COMMUNICATION_SUCCESS,
  RESET_USERS_LIST,
} from "./actionTypes"

const INIT_STATE = {
  notifications: null,
  loading: false,
  error: "",
  customEmails: null,
  webAlerts: null,
  events: [],
  isDeleteCommunicationModalOpen: false,
  communication: null,
  isSendCommunicationModalOpen: false,
  isSendWebAlertModalOpen: false,
  individualUsers: null,
}

const Communications = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
      }
    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
        loading: false,
      }
    case GET_NOTIFICATIONS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_CUSTOM_EMAILS:
      return {
        ...state,
        loading: true,
      }
    case GET_CUSTOM_EMAILS_SUCCESS:
      return {
        ...state,
        customEmails: action.payload,
        loading: false,
      }
    case GET_CUSTOM_EMAILS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_WEB_ALERTS:
      return {
        ...state,
        loading: true,
      }
    case GET_WEB_ALERTS_SUCCESS:
      return {
        ...state,
        webAlerts: action.payload,
        loading: false,
      }
    case GET_WEB_ALERTS_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_EVENTS_BY_SEARCH_SUCCESS:
      return {
        ...state,
        events: action.payload,
      }
    case GET_EVENTS_BY_SEARCH_FAILED:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_COMMUNICATION_FAILED:
      return {
        ...state,
        error: action.payload,
      }
    case OPEN_DELETE_COMMUNICATION_MODAL:
      return {
        ...state,
        isDeleteCommunicationModalOpen: true,
      }
    case HIDE_DELETE_COMMUNICATION_MODAL:
      return {
        ...state,
        isDeleteCommunicationModalOpen: false,
      }
    case DELETE_COMMUNICATION:
      return {
        ...state,
        loading: true,
      }
    case DELETE_COMMUNICATION_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_COMMUNICATION_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_COMMUNICATION:
      return {
        ...state,
        loading: true,
      }
    case GET_COMMUNICATION_SUCCESS:
      return {
        ...state,
        communication: action.payload,
        loading: false,
      }
    case GET_COMMUNICATION_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case RESET_COMMUNICATION:
      return {
        ...state,
        communication: null,
      }
    case UPDATE_COMMUNICATION:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_COMMUNICATION_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case UPDATE_COMMUNICATION_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case OPEN_SEND_COMMUNICATION_MODAL:
      return {
        ...state,
        isSendCommunicationModalOpen: true,
      }
    case HIDE_SEND_COMMUNICATION_MODAL:
      return {
        ...state,
        isSendCommunicationModalOpen: false,
      }
    case SEND_COMMUNICATION:
      return {
        ...state,
        loading: true,
      }
    case SEND_COMMUNICATION_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case SEND_COMMUNICATION_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case OPEN_SEND_WEB_ALERT_MODAL:
      return {
        ...state,
        isSendWebAlertModalOpen: true,
      }
    case HIDE_SEND_WEB_ALERT_MODAL:
      return {
        ...state,
        isSendWebAlertModalOpen: false,
      }
    case SEND_WEB_ALERT:
      return {
        ...state,
        loading: true,
      }
    case SEND_WEB_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case SEND_WEB_ALERT_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_USERS_SUCCESS:
      return {
        ...state,
        individualUsers: action.payload,
      }
    case GET_USERS_FAILED:
      return {
        ...state,
        error: action.payload,
      }
    case RESET_USERS_LIST:
      return {
        ...state,
        individualUsers: null,
      }
    default:
      return state
  }
}

export default Communications
